import { render, staticRenderFns } from "./client-edit.vue?vue&type=template&id=83e4386a&scoped=true"
import script from "./client-edit.vue?vue&type=script&lang=js"
export * from "./client-edit.vue?vue&type=script&lang=js"
import style0 from "./client-edit.vue?vue&type=style&index=0&id=83e4386a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e4386a",
  null
  
)

export default component.exports